import React, { useState, useRef, useEffect } from "react";
import { Form, Input, Button, Select, Collapse, Divider, Checkbox, Row, Col, InputNumber, Space, Spin, message, Radio, Modal, Tooltip, Popconfirm } from "antd";
import constants from '../../../constants/constants';
import { InfoCircleOutlined, MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { COOKIE, getCookie } from "../../../services/cookie";
import { useHistory } from "react-router";
import TextArea from "antd/es/input/TextArea";
import { DOB } from "../../../globalFunctions/GlobalFunctions";
import PhoneInput from "react-phone-input-2";
import { fetchAdminApi, fetchApi } from "../../../services/api";

const { Panel } = Collapse;
const { Option } = Select;

const EditableCheatSheet = ({ customSelect, onSubmit, handlePronounChange, assessment, plan, customRadio }) => {
	const history = useHistory();
	const [form] = Form.useForm();
	const loginId = getCookie(COOKIE.ClientId);
	const loginType = getCookie(COOKIE.LoginType);
	let adminClientValuefromSession = JSON.parse(sessionStorage.getItem("adminClientValue"));
	const first_name =
		adminClientValuefromSession?.client_firstname &&
		adminClientValuefromSession?.client_lastname
			? `${adminClientValuefromSession.client_firstname} ${adminClientValuefromSession.client_lastname}`
			: "";
	const [countryPhoneCode, setcountryPhoneCode] = useState("");
	const hideButtons = sessionStorage.getItem("hideSelfAssessmentButtons") === "1";
	let initialValues = {
		first_name: first_name,
		age: adminClientValuefromSession?.age,
		gender: adminClientValuefromSession?.gender,
		presenting_problem_text: adminClientValuefromSession?.enquiry_info?.more_details,
		source: adminClientValuefromSession?.enquiry_info?.source,
		source_details: adminClientValuefromSession?.enquiry_info?.source_details,
		city: adminClientValuefromSession?.city,
		country: adminClientValuefromSession?.country_id,
		state: adminClientValuefromSession?.region_id,
		email: adminClientValuefromSession?.client_email,
		client_contact_number: adminClientValuefromSession?.enquiry_info?.client_contact_number,
		reason: adminClientValuefromSession?.enquiry_info?.reason,
	};
	const [selectedSubstances, setSelectedSubstances] = useState({});
	const [gamblingTypes, setGamblingTypes] = useState(constants.OtherGamblingTypeOptions);
	const [newGamblingTypes, setNewGamblingTypes] = useState('');
	const gamblingTypesInputRef = useRef(null);
	const [maritalStatus, setMaritalStatus] = useState(['Single', 'Divorced', 'Married', "in a Live-in Relationship", "Separated"]);
	const [newMaritalStatus, setNewMaritalStatus] = useState('');
	const maritalStatusInputRef = useRef(null);
	const [ethnicity, setEthnicity] = useState(constants.EthnicityList);
	const [newEthnicity, setNewEthnicity] = useState('');
	const ethnicityInputRef = useRef(null);
	const [religion, setReligion] = useState(constants.ReligionList);
	const [newReligion, setNewReligion] = useState('');
	const religionInputRef = useRef(null);
	const [selectedReasons, setSelectedReasons] = useState({});
	const [selectedMentalHealth, setSelectedMentalHealth] = useState([]);
	const [selectedMentalHealthOption, setSelectedMentalHealthOption] = useState([]);
	const [otherMajorHealthDetail, setOtherMajorHealthDetail] = useState("");
	const [loader, setLoader] = useState(false);
	const [selectedAttempts, setSelectedAttempts] = useState({});
	const [showSourceDetails, setShowSourceDetails] = useState(history.location.pathname === "/edit-self-assessment-summary" ? adminClientValuefromSession?.source : adminClientValuefromSession?.enquiry_info?.source === "8" ? true : false);
	const [showOtherRelation, setShowOtherRelation] = useState(false);
	const [showOtherReasonForCall, setShowOtherReasonForCall] = useState(false);
	const [showEducationDetails, setShowEducationDetails] = useState(false);
	const [isEmotional10Selected, setIsEmotional10Selected] = useState(false);
	const [isEmotional11Selected, setIsEmotional11Selected] = useState(false);
	const [isEmotional12Selected, setIsEmotional12Selected] = useState(false);
	const [isMedical8Selected, setIsMedical8Selected] = useState(false);
	const [isFamily1Selected, setIsFamily1Selected] = useState(null);
	const [meetingOptions, setMeetingOptions] = useState(['Al-anon', 'Alcoholics Anonymous', 'Cocaine Anonymous', 'Emotions Anonymous', "Families Anonymous", "Gamblers Anonymous", "Nar-Anon", 'Narcotics Anonymous']);
	const [newMeetingOptions, setNewMeetingOptions] = useState('');
	const meetingOptionsInputRef = useRef(null);
	const [birthOrder, setBirthOrder] = useState(['oldest', 'youngest', 'only', 'middle child']);
	const [newBirthOrder, setNewBirthOrder] = useState('');
	const birthOrderInputRef = useRef(null);
	const [living, setLiving] = useState(constants.LivingCondition);
	const [newLiving, setNewLiving] = useState('');
	const livingInputRef = useRef(null);
	const [livingArrange, setLivingArrange] = useState(constants.ResidenceType);
	const [newLivingArrange, setNewLivingArrange] = useState('');
	const livingArrangeInputRef = useRef(null);
	const [selectedLiving, setSelectedLiving] = useState('');
	const [styles, setStyles] = useState(null);
	const [listCountries, setCountries] = useState([]);
	const [tempState, setTempState] = useState([]);
	const [listStates, setListStates] = useState([]);
	const [isMedical4Selected, setIsMedical4Selected] = useState(false);
	const [isDrugModalOpen, setIsDrugModalOpen] = useState(false);
	const [isDrug4Selected, setIsDrug4Selected] = useState(false);
	const [isDrug8Selected, setIsDrug8Selected] = useState(false);
	const [isMedical6Selected, setIsMedical6Selected] = useState(false);
	const [selectedIllnesses, setSelectedIllnesses] = useState([]);
	const [otherIllness, setOtherIllness] = useState('');
	const [selectedExercises, setSelectedExercises] = useState([]);
	const [otherExercise, setOtherExercise] = useState('');
	const [lastCheckupStatus, setLastCheckupStatus] = useState('');
	const familySubstanceValue = Form.useWatch('family_substance', form);
	const familyMentalHealthValue = Form.useWatch('family_mental_health', form);
	const [cageScreeningList, setCageScreeningList] = useState(constants.CageScreeningPre);
	const presentingValues = Form.useWatch('presenting_problem_options', form) || [];
	const selectedGender = Form.useWatch('gender', form) || '';

	const fetchCountries = () => {
		return fetchApi(`/countries`, "get").then((res) => {
			if (res?.data?.length > 0) {
				setCountries(res.data);
				return res.data;
			} else {
				setCountries([]);
				return [];
			}
		});
	};
	const onChangeCountry = (val, option) => {
		fetchStates(option?.key);
		setcountryPhoneCode(option?.key);
		form.setFieldsValue({ state: null });
	};
	const fetchStates = (country_code) => {
		return fetchApi(`/states/${country_code}`, "get").then(
			(res) => {
				if (res?.data) {
					setTempState(res?.data);
					setListStates(res.data);
				} else {
					setListStates(null);
				}
			}
		);
	};
	const selectFilterOption = (input, option) =>
		option?.label?.toLowerCase().includes(input?.toLowerCase());

	//Function to check the contact number and set validation error using css
	const handleContactNo = (value) => {
		if (value === "" || value === null || value === undefined) {
			const stylesValidation = { border: '1px solid rgba(255, 77, 79)', };
			setStyles(stylesValidation);
		} else {
			setStyles(null);
		}
	};
	const [date, setDate] = useState({
		date: adminClientValuefromSession?.answers?.medical_3?.day ? Number(adminClientValuefromSession?.answers?.medical_3?.day) : null,
		month: adminClientValuefromSession?.answers?.medical_3?.month ? adminClientValuefromSession?.answers?.medical_3?.month : null,
		year: adminClientValuefromSession?.answers?.medical_3?.year ? Number(adminClientValuefromSession?.answers?.medical_3?.year) : null
	});
	const [dob, setDob] = useState({
		date: adminClientValuefromSession?.dob?.day ? Number(adminClientValuefromSession?.dob?.day) : null,
		month: adminClientValuefromSession?.dob?.month ? adminClientValuefromSession?.dob?.month : null,
		year: adminClientValuefromSession?.dob?.year ? Number(adminClientValuefromSession?.dob?.year) : null
	});
	//date of notes date onchange
	const handleDayChange = (value) => {
		setDate({
			...date,
			date: value
		});
	};
	const handleMonthChange = (value) => {
		setDate({
			...date,
			month: value
		});
	};
	const handleYearChange = (value) => {
		setDate({
			...date,
			year: value
		});
	};
	//Dob of user onchange
	const handleDobDayChange = (value) => {
		setDob({
			...dob,
			date: value
		});
	};
	const handleDobMonthChange = (value) => {
		setDob({
			...dob,
			month: value
		});
	};
	const handleDobYearChange = (value) => {
		setDob({
			...dob,
			year: value
		});
	};
	const addMeetingOptions = () => {
		if (!newMeetingOptions) return;
		setMeetingOptions([...meetingOptions, newMeetingOptions]);
		setNewMeetingOptions('');
		setTimeout(() => meetingOptionsInputRef.current?.focus(), 0);
	};
	const addBirthOrder = () => {
		if (!newBirthOrder) return;
		setBirthOrder([...birthOrder, newBirthOrder]);
		setNewBirthOrder('');
		setTimeout(() => birthOrderInputRef.current?.focus(), 0);
	};
	const addLiving = () => {
		if (!newLiving) return;
		setLiving([...living, newLiving]);
		setNewLiving('');
		setTimeout(() => livingInputRef.current?.focus(), 0);
	};
	const addLivingArrange = () => {
		if (!newLivingArrange) return;
		setLivingArrange([...livingArrange, newLivingArrange]);
		setNewLivingArrange('');
		setTimeout(() => livingArrangeInputRef.current?.focus(), 0);
	};
	const [isFamily8Selected, setIsFamily8Selected] = useState(false);
	// Handle checkbox change for reason
	const handleCheckboxReaChange = (reason, isChecked) => {
		setSelectedReasons((prev) => ({
			...prev,
			[reason]: { ...prev[reason], checked: isChecked, cause: isChecked ? prev[reason]?.cause || constants.ReasonValues[reason] : "", },
		}));
	};
	// Handle checkbox change for MENTAL HEALTH
	const handleCheckboxMentalHealth = (val) => {
		setSelectedMentalHealth(val);
	};

	// Handle checkbox change for MENTAL HEALTH Option
	const handleCheckboxMentalHealthOption = (val) => {
		setSelectedMentalHealthOption(val);
	};

	const addGamblingTypes = () => {
		if (!newGamblingTypes) return;
		setGamblingTypes([...gamblingTypes, newGamblingTypes]);
		setNewGamblingTypes('');
		setTimeout(() => gamblingTypesInputRef.current?.focus(), 0);
	};

	const addReligion = () => {
		if (!newReligion) return;
		setReligion([...religion, newReligion]);
		setNewReligion('');
		setTimeout(() => religionInputRef.current?.focus(), 0);
	};

	const addEthnicity = () => {
		if (!newEthnicity) return;
		setEthnicity([...ethnicity, newEthnicity]);
		setNewEthnicity('');
		setTimeout(() => ethnicityInputRef.current?.focus(), 0);
	};

	const addMaritalStatus = () => {
		if (!newMaritalStatus) return;
		setMaritalStatus([...maritalStatus, newMaritalStatus]);
		setNewMaritalStatus('');
		setTimeout(() => maritalStatusInputRef.current?.focus(), 0);
	};

	const handleCheckboxSubChange = (substance, isChecked, index = null) => {
		if (index !== null) {
			setSelectedSubstances((prev) => (
				{
					...prev,
					[substance]: { ...prev[substance], [index]: { checked: isChecked } },
				}));
		} else {
			setSelectedSubstances((prev) => (
				{
					...prev,
					[substance]: { ...prev[substance], checked: isChecked },
				}));
		}
	};
	// Handle checkbox change for attempts
	const handleCheckboxAttemptChange = (attempt, isChecked) => {
		// Step 1: Compute the new state of selectedAttempts
		const updatedAttempts = {
			...selectedAttempts,
			[attempt]: { ...selectedAttempts[attempt], checked: isChecked },
		};
		setSelectedAttempts(updatedAttempts);

		// Step 2: Update the CageScreeningList based on updatedAttempts
		setCageScreeningList((prev) =>
			prev.map((item) => {
				if (attempt === "B") {
					// If B is selected, disable all others
					if (isChecked) {
						return item.key !== "B"
							? { ...item, disable: true }
							: { ...item, disable: false };
					} else {
						// Re-enable all if B is unchecked
						return { ...item, disable: false };
					}
				} else {
					// If any of C, A, G, E are checked
					if (isChecked) {
						return item.key === "B" ? { ...item, disable: true } : item;
					} else {
						// Re-enable B only if none of the other options are selected
						const othersStillChecked = Object.entries(updatedAttempts).some(
							([key, val]) => key !== "B" && val.checked
						);
						return item.key === "B"
							? { ...item, disable: othersStillChecked }
							: item;
					}
				}
			})
		);
	};

	const handleAgeChange = (substance, age, index = null) => {
		if (index !== null) {
			setSelectedSubstances((prev) => ({
				...prev,
				[substance]: {
					...prev[substance],
					[index]: {
						...prev[substance]?.[index],
						age,
					},
				},
			}));
		} else {
			setSelectedSubstances((prev) =>
			({
				...prev,
				[substance]: { ...prev[substance], age },
			}));
		}
	};

	const handleGamblingChange = (substance, value) => {
		setSelectedSubstances((prev) => (
			{
				...prev,
				[substance]: { ...prev[substance], textValue: value },
			}));
	};

	const handleFamily1Change = (value) => {
		setIsFamily1Selected(value === 'only');
	};

	const validatePanel3 = () => Object.values(selectedSubstances).some(item => item.checked);
	const validatePanel4 = () => Object.values(selectedAttempts).some(item => item.checked);
	const validatePanel5 = () => Object.values(selectedReasons).some(item => item);
	const validatePanel6 = () => Object.values(selectedMentalHealth).some(item => item);

	const handleSave = async (type = null) => {
		try {
			await form.validateFields();
			setLoader(true);
			let userAnswerValue = form.getFieldsValue();
			if (selectedReasons) userAnswerValue.selectedreasons = selectedReasons;
			if (selectedSubstances) userAnswerValue.selectedsubstances = selectedSubstances;
			if (selectedAttempts) userAnswerValue.selectedattempts = selectedAttempts;
			if (selectedMentalHealth) userAnswerValue.emotional_2 = selectedMentalHealth;
			if (selectedExercises) userAnswerValue.excercise = selectedExercises;
			if (selectedMentalHealthOption.length > 0) userAnswerValue.mentalhealthoption = selectedMentalHealthOption;
			userAnswerValue.medical_3 = date;
			userAnswerValue.selected_illnesses = selectedIllnesses;
			userAnswerValue.other_major_health_detail = otherMajorHealthDetail;
			const selectedCountry = listCountries.find(
				(country) => country.country_id === userAnswerValue.country
			);
			const selectedState = Object.values(tempState).flatMap((v) => v?.states || []).find(
				(state) => state.region_id === userAnswerValue.state
			);
			userAnswerValue.location = [userAnswerValue.city, selectedState?.region_name, selectedCountry?.country_name]
				.filter(Boolean)
				.join(", ");
			let listChildren = userAnswerValue?.children?.filter(item => item && item.name && item.age !== undefined);
			let childrenResult = {
				count: listChildren?.length || '',
				names: listChildren?.map(item => item.name).join(", ") || '',
				ages: listChildren?.map(item => item.age).join(", ") || ''
			};
			userAnswerValue.family_6 = listChildren?.length > 0 ? "has" : "has no";
			userAnswerValue.children_name = childrenResult?.names ? childrenResult?.names : '';
			userAnswerValue.family_7 = childrenResult?.ages ? childrenResult?.ages : '';
			let listSiblings = userAnswerValue?.siblings?.filter(item => item && item.name && item.age !== undefined);
			let siblingResult = {
				count: listSiblings?.length || '',
				names: listSiblings?.map(item => item.name).join(", ") || '',
				ages: listSiblings?.map(item => item.age).join(", ") || ''
			};
			userAnswerValue.sibling_names = siblingResult?.names ? siblingResult?.names : '';
			userAnswerValue.sibling_ages = siblingResult?.ages ? siblingResult?.ages : '';
			userAnswerValue.family_2 = siblingResult?.count ? siblingResult?.count : '';

			let siblingCombined = listSiblings?.map(
				item => `${item.name} (${item.age})`
			).join(", ") || '';

			userAnswerValue.sibling_display = siblingCombined;
			userAnswerValue.birthdate = dob;

			// Call Parent's function with type and callback
			onSubmit(userAnswerValue, type, true, (success) => {
				if (success) {
					setLoader(false);
					form.resetFields();
					setSelectedReasons({});
					setSelectedSubstances({});

					if (type === "esign") {
						message.success("Self-Assessment Summary e-signed successfully");
						history.push("/notes");
					} else {
						if (history.location.pathname === "/edit-self-assessment-summary") {
							history.push("/notes");
						} else {
							if (loginType === "0") {
								callUpdateSection();
							} else {
								history.push("/client-list-open");
							}
						}
						message.success("Self-Assessment Summary saved successfully");
					}
				} else {
					message.error(type === "esign" ? "E-sign failed" : "Self-Assessment Summary failed");
					setLoader(false);
				}
			});
		}
		catch (error) {
			console.error(type === "esign" ? "Esign" : "Save", "failed:", error);
			if (error.errorFields && error.errorFields.length > 0) {
				form.scrollToField(error.errorFields[0].name, {
					behavior: 'smooth',
					block: 'center',
				});
			}
			setLoader(false);
		}
	};

	const callUpdateSection = () => {
		setLoader(true);
		let payload = {
			flag: "6",
			section_id: "0"
		}
		fetchAdminApi(`/update-client-sections/${loginId}`, "put", payload).then((res) => {
			if (res?.code === 200) {
				setLoader(false);
				history.push({
					pathname: "/dashboard",
				});
			} else {
				message.error(res.message);
				setLoader(false);
			}
		})
	};

	const SHOW_SELECT_KEYS = ["social_use", "religious_use"];
	const EXCLUDED_KEYS_FOR_AGE = ["not_applicable", "other", "social_use", "religious_use", "social_gambling", "no_gambling"];
	const selectOptions = constants.Substances
		.filter((s) => !EXCLUDED_KEYS_FOR_AGE.includes(s.key))
		.flatMap((s) => {
			if (s.key === "nicotine_vapes" && s.nicotineOptions) {
				// Add nicotine sub-options
				return s.nicotineOptions.map((opt) => ({
					value: `${s.key}_${opt.value}`, // e.g., nicotine_vapes_smoking
					label: `${s.substances} - ${opt.label}`, // e.g., Nicotine/Vapes - Smoking
				}));
			}
			return {
				value: s.key,
				label: s.substances,
			};
		});

	const drugsForm = (selectedKey) => {
		return (
			<div className="flex flex-col">
				<Space direction="vertical" className="mb-3">
					{constants.Substances.filter(sub => sub.key === selectedKey).map((substance) => {
						const isChecked = selectedSubstances?.[substance.key]?.checked;

						return (
							<Form.Item key={substance.key} className="mb-0">
								<div className="flex items-center">
									<Checkbox
										onChange={(e) => handleCheckboxSubChange(substance.key, e.target.checked)}
										checked={!!isChecked}
									>
										<p className="text-[14px] font-bold">{substance.substances}</p>
									</Checkbox>

									{/* Show "at age" if substance is checked and not in exclusion list */}
									{isChecked && !EXCLUDED_KEYS_FOR_AGE.includes(substance.key) && (
										<>
											<b className="text-[14px] font-normal mr-2">at age</b>
											<InputNumber
												value={selectedSubstances?.[substance.key]?.age ?? ""}
												placeholder="Enter age"
												min={1}
												style={{ width: 100 }}
												onChange={(value) => handleAgeChange(substance.key, value)}
											/>
										</>
									)}
									{isChecked && SHOW_SELECT_KEYS.includes(substance.key) && (
										<Select
											placeholder="Select context"
											value={selectedSubstances?.[substance.key]?.usageContext ?? []}
											mode="multiple"
											className="!w-full md:!w-1/2"
											options={selectOptions}
											onChange={(value) =>
												setSelectedSubstances((prev) => ({
													...prev,
													[substance.key]: {
														...prev[substance.key],
														usageContext: value,
													},
												}))
											}
											allowClear
										/>
									)}
									{isChecked && ["social_gambling"].includes(substance.key) && (
										customSelect(true, "Select or enter types:", "tags", gamblingTypes, addGamblingTypes, newGamblingTypes, (e) => setNewGamblingTypes(e.target.value), gamblingTypesInputRef, undefined,
											(value) => setSelectedSubstances((prev) => ({
												...prev,
												social_gambling: {
													...prev.social_gambling,
													usageContext: value,
												}
											})),
											"!w-full md:!w-1/2", selectedSubstances?.social_gambling?.usageContext ?? [])
									)}
								</div>

								{/* Gambling & Other Special Cases */}
								{isChecked && substance.key === "gambling" && (
									<>
										{substance.gamblingOptions.map((val) => (
											<div key={val.value} className="ml-5 mt-2">
												<Checkbox
													onChange={(e) =>
														handleCheckboxSubChange(substance.key, e.target.checked, val.value)
													}
													checked={
														selectedSubstances?.[substance.key][val.value]?.checked || false
													}
												>
													<p className="text-[14px] font-bold">{val.label}</p>
												</Checkbox>
											</div>
										))}
										<p className="text-[14px] ml-5 mt-1">Type of gambling:</p>
										{selectedSubstances?.[substance.key]?.textValue && <div className="mt-2 ml-5">
											<TextArea
												value={selectedSubstances?.[substance.key]?.textValue || ""}
												onChange={(e) =>
													handleGamblingChange(substance.key, e.target.value)
												}
												rows={1}
											/></div>}
										<Form.Item name="type_gambling" label={""} className="text-[14px] ml-5 mt-1">
											{customSelect(true, "Select or enter types:", "tags", gamblingTypes, addGamblingTypes, newGamblingTypes, (e) => setNewGamblingTypes(e.target.value), gamblingTypesInputRef)}
										</Form.Item>
									</>
								)}

								{isChecked && substance.key === "other" && (
									<div className="mt-2 ml-5">
										<TextArea
											value={selectedSubstances?.[substance.key]?.textValue || ""}
											onChange={(e) =>
												handleGamblingChange(substance.key, e.target.value)
											}
											rows={4}
										/>
									</div>
								)}

								{/* Default Description */}
								{!["gambling", ...EXCLUDED_KEYS_FOR_AGE].includes(substance.key) && (
									<>
										<span className="text-blue-500 text-[14px] ml-5">
											{constants.SubstancesAliases[substance.key] || ""}
										</span>
										<p className="text-blue-500 text-[14px] ml-5 italic font-bold">
											{constants.SubstancesDescriptions[substance.key] || ""}
										</p>
									</>
								)}

								{/* Nicotine Options */}
								{isChecked && substance.key === "nicotine_vapes" &&
									substance.nicotineOptions.map((val) => (
										<div key={val.value} className="ml-5 mt-2">
											<Checkbox
												onChange={(e) =>
													handleCheckboxSubChange(substance.key, e.target.checked, val.value)
												}
												checked={
													selectedSubstances?.[substance.key][val.value]?.checked || false
												}
											>
												<p className="text-[14px] font-bold">{val.label}</p>
											</Checkbox>

											{selectedSubstances?.[substance.key][val.value]?.checked && (
												<>
													<b className="text-[14px] font-normal mr-2">at age</b>
													<InputNumber
														value={selectedSubstances?.[substance.key][val.value]?.age ?? ""}
														placeholder="Enter age"
														min={1}
														style={{ width: 100 }}
														onChange={(age) => handleAgeChange(substance.key, age, val.value)}
													/>
												</>
											)}
										</div>
									))}
							</Form.Item>
						);
					})}
				</Space>
			</div>
		);
	};

	const panelTitle = (title) => {
		return <div className='mt-5 mb-4 text-base italic underline font-bold'>{title}</div>
	};

	useEffect(() => {
		setLoader(true);
		fetchCountries().then((countries) => {
			const countryId =
				adminClientValuefromSession?.answers?.country ||
				adminClientValuefromSession?.enquiry_info?.recovery_plan_answers?.country ||
				adminClientValuefromSession?.country_id ||
				adminClientValuefromSession?.enquiry_info?.country_id;

			const countryCode =
				adminClientValuefromSession?.country_code ||
				adminClientValuefromSession?.enquiry_info?.country_code ||
				countries.find((c) => String(c.country_id) === String(countryId))?.country_code;

			const statePromise = countryCode ? fetchStates(countryCode) : Promise.resolve();

			statePromise.finally(() => {
				let userDetails = history.location.pathname === "/edit-self-assessment-summary" ? adminClientValuefromSession.answers : initialValues;

				if (
					adminClientValuefromSession?.answers &&
					typeof adminClientValuefromSession.answers === "object"
				) {
					initialValues = {
						...userDetails,
						...adminClientValuefromSession.answers,
						country_code: countryCode,
					};
				}

				setFormFields(initialValues);
				handlePronounChange(adminClientValuefromSession?.gender);
				setLoader(false);
			});
		});
	}, []);

	const setFormFields = (value) => {
		form.setFieldsValue(value);
		if (value?.source) setShowSourceDetails(value?.source === "8" || value?.source === "9" ? true : false);
		if (value?.selectedreasons) setSelectedReasons(value?.selectedreasons);
		if (value?.emotional_2) setSelectedMentalHealth(value?.emotional_2);
		if (value?.selectedsubstances) setSelectedSubstances(value?.selectedsubstances);
		if (value?.selectedattempts) setSelectedAttempts(value?.selectedattempts);
		if (value?.mentalhealthoption) setSelectedMentalHealthOption(value?.mentalhealthoption);
		if (value?.birthdate) setDob(value?.birthdate);
		if (value?.medical_3) setDate(value?.medical_3);
		if (value?.medical_4) setIsMedical4Selected(value?.medical_4 === "Allergies");
		if (value?.medical_6) setIsMedical6Selected(value?.medical_6 === "illnesses/disease");
		if (value?.drug_4) setIsDrug4Selected(value?.drug_4 === 'never been');
		if (value?.drug_8) setIsDrug8Selected(value?.drug_8 === 'yes');
		if (value?.emotional_10) setIsEmotional10Selected(value?.emotional_10 === 'received');
		if (value?.emotional_11) setIsEmotional11Selected(value?.emotional_11 === 'was');
		if (value?.emotional_12) setIsEmotional12Selected(value?.emotional_12 === 'medication');
		if (value?.medical_8) setIsMedical8Selected(value?.medical_8 === "medications/OTCs");
		if (value?.family_8) setIsFamily8Selected(value?.family_8 === "current");
		if (value?.relation_to_recipient) setShowOtherRelation(value?.relation_to_recipient === "15");
		if (value?.reason) setShowOtherReasonForCall(value?.reason === "9");
		if (value?.family_10) setShowEducationDetails(value?.reason === "14" || value?.reason === "15");
		if (value?.excercise) setSelectedExercises(value?.excercise);
		if (value?.selected_illnesses) setSelectedIllnesses(value?.selected_illnesses);
		if (value?.other_major_health_detail) setOtherMajorHealthDetail(value?.other_major_health_detail);
		if (value?.family_1) setIsFamily1Selected(value?.family_1 === 'only');
		if (value?.family_3) setSelectedLiving(value?.family_3);
	};

	const updatedReasons = constants.Reasons.map((reason) => ({
		...reason,
		reason: reason.reason.replace(/\slike$/, "") // Remove " like" at the end if it exists
	}));

	const onChangeSourse = (val) => {
		setShowSourceDetails(val === "8" || val === "9" ? true : false);
	};

	// Handle input change for cause
	const handleCauseChange = (reason, cause) => {
		setSelectedReasons((prev) => ({
			...prev,
			[reason]: { ...prev[reason], cause },
		}));
	};

	const handleNestedCauseChange = (reason, cause, checked) => {
		setSelectedReasons((prevSelectedReasons) => ({
			...prevSelectedReasons,
			[reason]: {
				...prevSelectedReasons[reason],
				causes: {
					...prevSelectedReasons[reason]?.causes,
					[cause]: checked
				}
			}
		}));
	};

	const handleEmotional10Change = (value) => {
		setIsEmotional10Selected(value === "received");
	};

	const handleEmotional11Change = (value) => {
		setIsEmotional11Selected(value === "was");
	};

	const handleEmotional12Change = (value) => {
		setIsEmotional12Selected(value === "medication");
	};

	const handleMedical8Change = (value) => {
		setIsMedical8Selected(value === "medications/OTCs");
	};


	const handleFamily8Change = (value) => {
		setIsFamily8Selected(value === 'current');
	};

	const handleRelationRecipient = (val) => {
		setShowOtherRelation(val === "15" ? true : false);
	};

	const handleReasonForCall = (val) => {
		setShowOtherReasonForCall(val === "9" ? true : false);
	};

	const handleEducationChange = (val) => {
		setShowEducationDetails(val === "14" || val === "15" ? true : false);
	};

	const onlyEmotionalOrFamily =
		presentingValues?.some((val) => ["4", "5", "6"]?.includes(val)) &&
		!presentingValues?.some((val) => ["1", "2", "3"]?.includes(val));

	const dynamicForm = (listKey) => {
		return <Form.List name={[listKey]}>
			{(fields, { add, remove }) => (
				<>
					{fields.map(({ key, name, ...restField }) => (
						<>
							<Col xs={24} lg={10}>
								<Form.Item
									{...restField}
									name={[name, 'name']}
									rules={[
										{
											required: true,
											message: 'Missing name',
										},
									]}
								>
									<Input placeholder="Name" />
								</Form.Item>
							</Col>
							<Col xs={20} lg={10}>
								<Form.Item
									{...restField}
									name={[name, 'age']}
									rules={[
										{
											required: true,
											message: 'Missing age',
										},
									]}
								>
									<InputNumber placeholder="Age" min={1} className="w-full" />
								</Form.Item>
							</Col>
							<Col xs={4} lg={4}>
								<MinusCircleOutlined onClick={() => remove(name)} />
							</Col>
						</>
					))}
					<Col xs={24} lg={12}>
						<Form.Item>
							<Button type='primary' className='bg-sky-800 text-white uppercase' onClick={() => add()} icon={<PlusOutlined />}>
								Add {listKey === "siblings" ? "sibling(s)" : listKey}
							</Button>
						</Form.Item>
					</Col>
				</>
			)}
		</Form.List>
	};

	const handleMedical4Change = (value) => {
		setIsMedical4Selected(value === "Allergies");
	};

	const handleDrug4Change = (value) => {
		setIsDrug4Selected(value === 'never been');
	};
	const handleDrug8Change = (value) => {
		setIsDrug8Selected(value === 'yes');
	};
	const handleMedical6Change = (value) => {
		setIsMedical6Selected(value === "illnesses/disease");
	};
	const handleIllnessChange = (values) => {
		setSelectedIllnesses(values);
		if (!values.includes('Other')) setOtherIllness('');
	};

	// Handle checkbox changes
	const handleExerciseChange = (checkedValues) => {
		if (checkedValues.includes('None')) {
			setSelectedExercises(['None']);
			setOtherExercise('');
		} else {
			setSelectedExercises(checkedValues.filter(val => val !== 'None'));
		}

		if (!checkedValues.includes('Other')) {
			setOtherExercise('');
		}
	};

	// Prepare final value
	useEffect(() => {
		const isNoneSelected = selectedExercises.includes('None');

		const family_13_value = isNoneSelected ? "inactive" : "active";
		const family_14_value = isNoneSelected ? "does no" : "does";

		const finalExercises = selectedExercises
			.filter(val => val !== 'Other')
			.concat(otherExercise ? [otherExercise] : []);

		const family_15_value = finalExercises.join(', ');
		form.setFieldsValue({
			family_13: family_13_value,
			family_14: family_14_value,
			family_15: family_15_value
		});
	}, [selectedExercises, otherExercise]);

	const handleCheckupChange = (value) => {
		setLastCheckupStatus(value === "1");
	};

	useEffect(() => {
		// only add 'gambling' key if it's completely undefined
		setSelectedSubstances((prev) => {
			if (!prev?.gambling) {
				return {
					...prev,
					gambling: { checked: false }
				};
			} else if (!prev?.no_gambling) {
				return {
					...prev,
					no_gambling: { checked: false }
				};
			} else if (!prev?.social_gambling) {
				return {
					...prev,
					social_gambling: { checked: false }
				};
			}
			return prev; // don't overwrite existing values
		});
	}, []);

	const substanceOrder = constants.Substances.map(sub => sub.key).filter(key => key !== "gambling" && key !== "no_gambling" && key !== "social_gambling");

	// Extract selected non-gambling substances
	const sortedSelectedKeys = Object.entries(selectedSubstances)
		.filter(([key, value]) => key !== "gambling" && key !== "no_gambling" && key !== "social_gambling" && value.checked)
		.map(([key]) => key)
		.sort((a, b) => substanceOrder.indexOf(a) - substanceOrder.indexOf(b));

	// Check and add no_gambling and social_gambling if selected
	sortedSelectedKeys.push("no_gambling");
	sortedSelectedKeys.push("social_gambling");

	// Always add gambling last
	sortedSelectedKeys.push("gambling");

	const filteredIllnessOptions = constants.illnessOptions.filter(option => {
		if (option.value === 'pregnant') {
			return selectedGender === 'Female';
		}
		return true;
	});

	const hideModal = () => {
		history.push({ pathname: '/notes' });
	};

	return (
		<Spin spinning={loader} size="large">
			<Form
				form={form}
				layout="vertical"
				className="client-details"
			>
				{panelTitle("Presenting Problem:")}
				<Row gutter={16}>
					<Col xs={24} lg={24}>
						{/* <Form.Item name="patient_problem" noStyle>
							<Radio.Group className="hidden invisible">
								<Radio value="2">{constants.FamilyMember}</Radio>
								<Radio value="1">{constants.AddictsGamblers}</Radio>
								<Radio value="3">{constants.Emotional}</Radio>
								<Radio value="0">{constants.General}</Radio>
							</Radio.Group>
						</Form.Item> */}
						<Col xs={24} lg={24} >
							<Form.Item name={"problem_1"} label="Mode of meeting" noStyle>
								<Select placeholder="online/in-person" allowClear hidden>
									<Option value="online">online</Option>
									<Option value="in-person">in-person</Option>
									<Option value="over the phone">over the phone</Option>
								</Select>
							</Form.Item>
						</Col>
						<Form.Item
							name="presenting_problem_options"
							rules={[
								{
									type: 'array',
								},
							]}
						>
							<Checkbox.Group options={constants.PatientProblems} disabled />
						</Form.Item>
					</Col>
					<Col xs={24} md={12} lg={8}>
						<Form.Item
							label={constants.ReasonForCall}
							name="reason"
							rules={[
								{
									required: true,
									message: "Please select one option!",
								},
							]}
						>
							<Select placeholder={constants.ReasonForCall} allowClear onChange={handleReasonForCall}>
								{constants.ReasonForCallOptions.map((val) => {
									return <Option key={val.value} value={val.value}>{val.label}</Option>
								})}
							</Select>
						</Form.Item>
					</Col>
					{
						showOtherReasonForCall ?
							<Col xs={24} md={12} lg={8}>
								<Form.Item
									name={"other_reasonforcall"}
									label={constants.OtherDetails}
								>
									<Input type="text" />
								</Form.Item>
							</Col> : null
					}
					<Col xs={24} md={12} lg={8}>
						<Form.Item
							label={constants.Source}
							name={"source"}
							rules={[
								{
									required: true
								},
							]}
						>
							<Select
								size="middle"
								placeholder={constants.SourcePlaceHolder}
								options={constants.SourceOption}
								onChange={onChangeSourse}
							/>
						</Form.Item>
					</Col>
					{
						showSourceDetails ?
							<Col xs={24} md={12} lg={8}>
								<Form.Item
									name={"source_details"}
									label={"Source Details"}
								>
									<Input type="text" />
								</Form.Item>
							</Col> : null
					}
					<Col xs={24} lg={24}>
						<Form.Item
							name="presenting_problem_text"
							className='mb-0'
							label={constants.MoreDetails}
						>
							<TextArea rows={2} />
						</Form.Item>
					</Col>
				</Row>
				<Col xs={24} lg={24}>
					<Form.Item
						name="presenting_problem_detail"
						className='mb-3'
						label={`Reason Discussed ${adminClientValuefromSession?.answers?.problem_1 ? "(" + adminClientValuefromSession?.answers?.problem_1 + ")" : ""}`}
					>
						<TextArea rows={3} placeholder="Write brief notes." />
					</Form.Item>
				</Col>
				<Divider className="my-7" />

				{panelTitle("Basic Information:")}

				<Row gutter={16}>
					<Col xs={24} md={12} lg={8}>
						<Form.Item
							label="Name"
							name="first_name"
							rules={[
								{
									required: true,
									message: "Enter name",
									whitespace: true
								},
							]}
						>
							<Input placeholder="Enter name" />
						</Form.Item>
					</Col>
					<Col xs={24} md={12} lg={8}>
						<Form.Item
							label={constants.phone}
							name={"client_contact_number"}
							rules={[
								{
									required: true,
									message: constants.PhoneNoRegistration,
								},
							]}
						>
							<PhoneInput preferredCountries={["us", "in"]} className='w-full' country={countryPhoneCode ? countryPhoneCode.toLocaleLowerCase() : "in"} style={styles} onChange={handleContactNo} placeholder="1(999)123-4567" />
						</Form.Item>
					</Col>
					<Col xs={24} md={12} lg={8}>
						<Form.Item
							name="email"
							hasFeedback
							label={constants.Email}
							rules={[
								{
									required: true,
									message: constants.EmailRegistration,
								},
								{
									type: 'email',
									message: constants.emailVaidationError,
								},
							]}
						>
							<Input
								placeholder={constants.EmailPlaceholder}
							/>
						</Form.Item>
					</Col>
					<Col xs={24} md={12} lg={8}>
						{DOB(dob.month, handleDobMonthChange, dob.date, handleDobDayChange, dob.year, handleDobYearChange, constants.dob)}
					</Col>
					<Col xs={24} md={12} lg={8}>
						<Form.Item
							label="Age"
							name="age"
							rules={[
								{
									required: true,
									message: "Enter age",
								},
							]}
						>
							<InputNumber className="w-full" min={1} placeholder="Enter age" />
						</Form.Item>
					</Col>

					<Col xs={24} md={12} lg={8}>
						<Form.Item
							label={constants.Gender}
							name="gender"
							rules={[
								{
									required: true,
									message: "Select gender",
								},
							]}
						>
							<Select placeholder="Male/Female" allowClear onChange={handlePronounChange}>
								<Option value="Male">Male</Option>
								<Option value="Female">Female</Option>
								<Option value="Other">Other</Option>
							</Select>
						</Form.Item>
					</Col>

					{selectedGender === 'Other' && (<Col xs={24} md={12} lg={8}>
						<Form.Item
							label="Other Gender Details"
							name="gender_details"
						>
							<Input placeholder="Enter other Gender Details" />
						</Form.Item>
					</Col>)}

					<Col xs={24} md={12}>
						<Form.Item
							label={constants.SexualOrientation}
							name="sexula_orientation"
							rules={[
								{
									required: true,
									message: "Select" + " " + constants.SexualOrientation,
								},
							]}
						>
							<Select placeholder={constants.SexualOrientation} allowClear>
								{
									constants.SexualOrientationOption.map((val) => {
										return <Option key={val.value} value={val.value}>{val.label}</Option>
									})
								}
							</Select>
						</Form.Item>
					</Col>
					<Col xs={24} md={12}>
						<Form.Item
							name={"intro_1"}
							label={constants.Status}
							rules={[
								{
									required: true,
									message: "Select status",
								},
							]}
						>
							{
								customSelect(
									true,
									"Single/Divorced/Married",
									null,
									maritalStatus,
									addMaritalStatus,
									newMaritalStatus,
									(e) => setNewMaritalStatus(e.target.value),
									maritalStatusInputRef
								)
							}
						</Form.Item>
					</Col>
					<Col xs={24} md={12} lg={8}>
						<Form.Item
							name="family_17"
							label="Residence Type"
							rules={[
								{
									required: true,
									message: "Enter residence type",
								},
							]}
						>
							{customSelect(true, "Bungalow Ownership/Bungalow Rental/Flat Ownership/Flat Rental", null, livingArrange, addLivingArrange, newLivingArrange, (e) => setNewLivingArrange(e.target.value), livingArrangeInputRef)}
						</Form.Item>
					</Col>
					<Col xs={24} md={12} lg={8}>
						<Form.Item
							label={constants.Ethnicity}
							name="intro_2"
							rules={[
								{
									required: true,
									message: "Select ethniticity",
								},
							]}
						>
							{customSelect(
								true,
								"Asian Indian/White/Black/Hispanic",
								null,
								ethnicity,
								addEthnicity,
								newEthnicity,
								(e) => setNewEthnicity(e.target.value),
								ethnicityInputRef
							)}
						</Form.Item>
					</Col>
					<Col xs={24} md={12} lg={8}>
						<Form.Item
							label={constants.Religion}
							name="intro_3"
							rules={[
								{
									required: true,
									message: "Select Religion",
								},
							]}
						>
							{customSelect(
								true,
								constants.ReligionPlaceHolder,
								null,
								religion,
								addReligion,
								newReligion,
								(e) => setNewReligion(e.target.value),
								religionInputRef
							)}
						</Form.Item>
					</Col>

					{loginType !== "0" && <>
						{constants.QuestionsPreAssessment
							.filter(q => q.name === "spiritual_3")
							.map((question) => (
								<div key={question.name} className="mb-6">
									{customRadio(question.name, question.question, question.yesValue, question.noValue)}
								</div>
							))
						}
					</>}

					<Col xs={24} md={12}>
						<Form.Item
							label="Spiritual and Religious Beliefs (Optional)"
							name="spiritual_1"
						>
							<Input.TextArea
								placeholder="How would you describe your Spiritual and / or Religious beliefs?"
								rows={1}
							/>
						</Form.Item>
					</Col>

					<Col xs={24} md={12}>
						<Form.Item
							label="How might your beliefs or values support your recovery?"
							name="spiritual_2"
							rules={[
								{
									required: true,
									message: "Please share how your beliefs, values, or practices might support your recovery"
								}
							]}
						>
							<Input.TextArea
								placeholder="How do you see your beliefs helping you in your recovery from alcohol and / or substance abuse?"
								rows={1}
							/>
						</Form.Item>
					</Col>

					<Col xs={24} md={12} lg={8}>
						<Form.Item
							label={constants.Address}
							name="address"
							rules={[
								{
									required: true,
									message: "Enter" + " " + constants.Address,
								},
							]}
						>
							<Input placeholder={constants.Address} />
						</Form.Item>
					</Col>
					<Col xs={24} md={12} lg={8}>
						<Form.Item
							label={constants.Apt}
							name="Apt"
						// rules={[
						// 	{
						// 		required: true,
						// 		message: "Enter" + " " + constants.Apt,
						// 	},
						// 	{
						// 		validator: (_, value) =>
						// 			value && value.toString().length <= 10
						// 				? Promise.resolve()
						// 				: Promise.reject(constants.AptErrorMessage),
						// 	}
						// ]}
						>
							<InputNumber placeholder={constants.Apt} className={"w-full"} />
						</Form.Item>
					</Col>
					<Col xs={24} md={12} lg={8}>
						<Form.Item
							label={constants.Pincode}
							name="pincode"
							rules={[
								{
									required: true,
									message: "Enter" + " " + constants.Pincode,
								},
							]}
						>
							<Input placeholder={constants.Pincode} className={"w-full"} />
						</Form.Item>
					</Col>
					<Col xs={24} md={12} lg={8}>
						<Form.Item
							label="City"
							name="city"
							rules={[
								{
									required: true,
									message: "Enter city",
								},
							]}
						>
							<Input placeholder="Enter city" />
						</Form.Item>
					</Col>
					<Col xs={24} md={12} lg={8}>
						<Form.Item
							label={constants.country}
							name="country"
							rules={[
								{
									required: true,
									message: constants.CountryRegistration,
								},
							]}
						>
							<Select
								onChange={onChangeCountry}
								placeholder={"Country"}
								className="w-100"
								showSearch
								allowClear
								filterOption={selectFilterOption}>
								{listCountries &&
									listCountries.map((listCountry) => (
										<Option key={listCountry.country_code} value={listCountry.country_id}>
											{listCountry.country_name}
										</Option>
									))}
							</Select>
						</Form.Item>
					</Col>
					<Col xs={24} md={12} lg={8}>
						<Form.Item
							label={constants.state}
							name="state"
							rules={[
								{
									required: true,
									message: constants.StateRegistration,
								},
							]}
						>
							<Select
								placeholder={constants.state}
								allowClear
								showSearch
								filterOption={selectFilterOption}
							>
								{tempState ?
									Object.entries(tempState).flatMap(([key, value]) =>
										value?.states?.map((state) => (
											<Option key={state.region_id} value={state.region_id}>
												{state.region_name}
											</Option>
										)) || []
									) :
									listStates &&
									Object.entries(tempState ? tempState : listStates).map(([key, value]) => (
										<>
											{value &&
												value.states &&
												value.states.length > 0 &&
												value.states.map((state) => (
													<Option
														key={state.region_id}
														value={state.region_id}
													>
														{state.region_name}
													</Option>
												))}
										</>
									))
								}
							</Select>
						</Form.Item>
					</Col>
					<Col xs={24} lg={24}>
						<Form.Item
							name="service"
							rules={[
								{
									required: true,
									message: "Please select one option!",
								},
							]}
							label={constants.ServiceText}
						>
							<Radio.Group>
								<Radio value="1">{constants.Yes}</Radio>
								<Radio value="2">{constants.No}</Radio>
							</Radio.Group>
						</Form.Item>
					</Col>
				</Row>
				<Divider className="mt-4 mb-7" />

				{panelTitle("Emergency Contact Info:")}
				<div className="-mt-3 mb-4 italic font-semibold">( We ask for an emergency contact for your safety, should anything unexpected occur during the session. )</div>

				<Row gutter={16}>
					<Col xs={24} md={12} lg={8}>
						<Form.Item
							label={constants.EmergencyContactName}
							name="emergency_contact_name"
							rules={[
								{
									required: true,
									message: "Enter" + " " + constants.EmergencyContactName,
									whitespace: true
								},
							]}
						>
							<Input type="text" placeholder="Enter Emergency Contact Name" />
						</Form.Item>
					</Col>
					<Col xs={24} md={12} lg={8}>
						<Form.Item
							label="Emergency Contact No."
							name="emergency_contact_number"
							rules={[
								{
									required: true,
									message: "Enter Emergency Contact No.",
									whitespace: true
								},
							]}
						>
							<PhoneInput preferredCountries={["us", "in"]} className='w-full' country={"in"} style={styles} onChange={handleContactNo} placeholder="1(999)123-4567" />
						</Form.Item>
					</Col>
					<Col xs={24} md={12} lg={8}>
						<Form.Item
							label="Emergency Contact Email"
							name="emergency_contact_email"
							rules={[
								{
									required: true,
									message: "Enter Emergency Contact Email",
									whitespace: true
								},
							]}
						>
							<Input type="email" placeholder="Enter Emergency Contact Email" />
						</Form.Item>
					</Col>
					<Col xs={24} md={12} lg={8}>
						<Form.Item
							name="relation_to_recipient"
							label={constants.RelationtoRecipient}
							rules={[
								{
									required: true,
									message: "Enter" + " " + constants.RelationtoRecipient,
									whitespace: true
								},
							]}
						>
							<Select placeholder={constants.RelationtoRecipient} allowClear onChange={handleRelationRecipient}>
								{constants.RelationtoRecipientOptions.map((val) => {
									return <Option key={val.value} value={val.value}>{val.label}</Option>
								})}
							</Select>
						</Form.Item>
					</Col>
					{
						showOtherRelation ?
							<Col xs={24} md={12} lg={8}>
								<Form.Item
									name={"other_relation_recipent"}
									label={constants.OtherDetails}
								>
									<Input type="text" />
								</Form.Item>
							</Col> : null
					}
					{/* <Col xs={24} lg={24}>
								<Form.Item
									name="is_signed_consentform"
									rules={[
										{
											required: true,
											message: "Please select one option!",
										},
									]}
									label={constants.IsSignedConsentForm}
								>
									<Radio.Group>
										<Radio value="1">{constants.Yes}</Radio>
										<Radio value="2">{constants.No}</Radio>
									</Radio.Group>
								</Form.Item>
							</Col> */}
				</Row>

				<Divider className="my-7" />
				{panelTitle("Substances/Gambling")}
				<p className="-mt-3 mb-2 italic font-semibold">( If you forgot to mention any substances you’ve used, please click the <b>"ADD DRUG(S)"</b> button to update your response for the counselor. )</p>
				<span className="text-sm font-medium">Please check/tick whatever substance you have used and enter the age that you have started using.</span>
				<div className="flex justify-end mt-0 mb-3"><Button className='bg-sky-800 text-white uppercase' onClick={() => setIsDrugModalOpen(true)} icon={<PlusOutlined />}>Add Drug(s)</Button></div>
				{sortedSelectedKeys.map((key) => (
					<div key={key}>
						{drugsForm(key)}
					</div>
				))}
				<Divider className="my-7" />

				<Row gutter={[12, 12]} className="mt-4">
					{loginType !== "0" && <>
						<Col xs={24} sm={12} lg={8}>
							{customRadio("substance_treat", 'Have you ever received any treatment or gone to AA or NA?', "yes", "no")}
						</Col>
						{constants.QuestionsPreAssessment
							.filter(q => q.name === "gambling_treat" || q.name === "community_support")
							.map((question) => (
								<Col xs={24} sm={12} lg={8} key={question.name}>
									{customRadio(question.name, question.question, question.yesValue, question.noValue)}
								</Col>
							))
						}
					</>}
					<Col xs={24} sm={12} lg={8}>
						<Form.Item name="drug_4" label={"Have you ever received treatment for addiction?"}>
							<Select placeholder={constants.YesNo} allowClear onChange={handleDrug4Change}>
								<Option value="been">{constants.Yes}</Option>
								<Option value="never been">{constants.No}</Option>
							</Select>
						</Form.Item>
					</Col>
					{!isDrug4Selected && <>
						<Col xs={24} sm={12} lg={8}>
							<Form.Item name="drug_5" label={"Institute"}>
								<Input placeholder={"Enter Institute"} />
							</Form.Item>
						</Col>
						<Col xs={24} sm={12} lg={8}>
							<Form.Item name={"drug_6"} label={"Therapist/Doctor"}>
								<Input placeholder={"Enter Therapist"} />
							</Form.Item>
						</Col>
					</>}
					<Col xs={24} sm={12} lg={8}>
						<Form.Item name="drug_8" label={"Any 12-step program experience?"}>
							<Select placeholder={constants.YesNo} allowClear onChange={handleDrug8Change}>
								<Option value="no">{constants.No}</Option>
								<Option value="yes">{constants.Yes}</Option>
							</Select>
						</Form.Item>
					</Col>
					{isDrug8Selected && (
						<Col xs={24} sm={12} lg={8}>
							<Form.Item
								name="drug_12"
								label="Meetings/services participated in"
							>
								{customSelect(true, "Select meetings/services attended:", "tags", meetingOptions, addMeetingOptions, newMeetingOptions, (e) => setNewMeetingOptions(e.target.value), meetingOptionsInputRef)}
							</Form.Item>
						</Col>)}
					<Col xs={24} sm={12} lg={8}>
						<Form.Item name="drug_7" label={"Any friends in recovery (from substances/gambling)?"}>
							<Select placeholder="no/some" allowClear>
								<Option value="no">{constants.No}</Option>
								<Option value="some">{constants.Some}</Option>
							</Select>
						</Form.Item>
					</Col>
					<Col xs={24} sm={12} lg={8}>
						<Form.Item name="drug_9" label={"Longest abstinence (from substances/gambling)?"}>
							<Input placeholder={"days/months/years"} />
						</Form.Item>
					</Col>
					<Col xs={24} md={16}>
						<Form.Item
							label="Family history of substance use or gambling problems"
							name="family_substance"
							rules={[
								{
									required: true,
									message: "Please select an option"
								}
							]}
						>
							<Radio.Group>
								<Radio value="none">No known family history</Radio>
								<Radio value="present">Yes, there is family history</Radio>
								<Radio value="unsure">Not sure/Prefer not to say</Radio>
							</Radio.Group>
						</Form.Item>
					</Col>

					{familySubstanceValue === 'present' && (
						<Col xs={24} md={8}>
							<Form.Item
								label="Family substance use or gambling history (In details)"
								name="family_substance_details"
								rules={[
									{
										required: true,
										message: "Please provide details about the family history"
									}
								]}
							>
								<Input.TextArea
									placeholder="e.g., which family members, types of substances/gambling, how it affected the family, etc."
									rows={1}
								/>
							</Form.Item>
						</Col>
					)}
				</Row>
				{onlyEmotionalOrFamily ? null : (<>	<Divider className="my-7" />

					{panelTitle("Here is your response to the CAGE screening. Please review it.")}
					{
						!validatePanel4() && ( // Show error message if validation fails
							<span className="text-red-500 text-sm">Have you experienced any of the following?</span>
						)
					}
					<Row gutter={[12, 12]}>
						{cageScreeningList.map((cage) => {
							return <Col xs={24} md={12} lg={12} key={cage.key}>
								<Checkbox
									onChange={(e) => handleCheckboxAttemptChange(cage.key, e.target.checked)}
									checked={selectedAttempts?.[cage.key] ? selectedAttempts[cage.key]?.checked : false}
									disabled={cage.disable}
								>
									<p>{cage.label}</p>
								</Checkbox>
							</Col>
						})}
					</Row></>)}
				<Divider className="my-7" />

				{panelTitle("Has the substance use/gambling affected any of the following")}

				{
					!validatePanel5() && ( // Show error message if validation fails
						<span className="text-red-500 text-sm">Please select at least one option.</span>
					)
				}
				<Row gutter={[12, 12]}>
					{updatedReasons.map((reason) => (
						<Col xs={24} lg={12} key={reason.key}>
							<Checkbox
								onChange={(e) => handleCheckboxReaChange(reason.key, e.target.checked)}
								checked={selectedReasons?.[reason.key]?.checked ? true : false}
							>
								<p>{reason.reason}</p>
							</Checkbox>
							{selectedReasons[reason.key]?.checked && !Array.isArray(constants.ReasonValues[reason.key]) && (
								<Input
									defaultValue={selectedReasons[reason.key]?.cause || constants.ReasonValues[reason.key]}
									value={selectedReasons[reason.key]?.cause ? selectedReasons[reason.key]?.cause : ""}
									placeholder="Enter cause"
									style={{ width: 600 }}
									onChange={(e) => handleCauseChange(reason.key, e.target.value)}
								/>
							)}
							{selectedReasons[reason.key]?.checked && Array.isArray(constants.ReasonValues[reason.key]) && (
								<Space direction="vertical">
									{constants.ReasonValues[reason.key].map((cause) => (
										<Checkbox
											key={cause}
											checked={selectedReasons[reason.key]?.causes?.[cause] || false}
											onChange={(e) => handleNestedCauseChange(reason.key, cause, e.target.checked)}
										>
											<p className="text-[14px] font-normal">{cause}</p>
										</Checkbox>
									))}
								</Space>
							)}
						</Col>
					))}
				</Row>
				<Divider className="my-7" />

				{panelTitle("Mental/Emotional Health")}
				{loginType !== "0" && <>
					{constants.QuestionsPreAssessment
						.filter(q => q.name === "mental_treat")
						.map((question) => (
							<div key={question.name} className="mb-6">
								{customRadio(question.name, question.question, question.yesValue, question.noValue)}
							</div>
						))
					}
				</>}
				<div className="text-sm font-medium">Has a professional ever diagnosed you with the following?</div>
				{
					!validatePanel6() && ( // Show error message if validation fails
						<div className="text-red-500 text-sm">Please select at least one Mental/Emotional Health.</div>
					)
				}
				<Checkbox.Group onChange={handleCheckboxMentalHealth} value={selectedMentalHealth}>
					<Row gutter={[12, 12]}>
						{constants.MentalHealth.map((health, index) => (
							<Col xs={24} sm={12} lg={8} key={index}>
								<Checkbox value={health}>
									<p>{health}</p>
								</Checkbox>
							</Col>
						))}
						<Col xs={24} sm={12} lg={8}>
							<Checkbox value={"Other"}>
								<p >Other</p>
							</Checkbox>
						</Col>
						{
							selectedMentalHealth.length > 0 && selectedMentalHealth.includes("Other") ?
								<Col xs={24} sm={24} lg={24}>
									<Form.Item name={"otherhealth"}>
										<TextArea placeholder={"Other Mental/Emotional Health..."} rows={4} />
									</Form.Item>
								</Col>
								: null
						}
					</Row>
				</Checkbox.Group>

				<Row gutter={[12, 12]} className="mt-4">
					<Col xs={24} sm={12} lg={8}>
						<Form.Item name="emotional_10" label={"Have you ever received treatment for the same?"}>
							<Select placeholder={constants.YesNo} allowClear onChange={handleEmotional10Change}>
								<Option value="received">{constants.Yes}</Option>
								<Option value="never received">{constants.No}</Option>
							</Select>
						</Form.Item>
					</Col>
					{isEmotional10Selected && (<Col xs={24} sm={12} lg={8}>
						<Form.Item name={"emotional_3"} label={"Therapist/Doctor"}>
							<Input placeholder={"Therapist"} />
						</Form.Item>
					</Col>)}
					<Col xs={24} sm={12} lg={8}>
						<Form.Item name="emotional_11" label={"Have you been hospitalized for the same?"}>
							<Select placeholder={constants.YesNo} allowClear onChange={handleEmotional11Change}>
								<Option value="was">{constants.Yes}</Option>
								<Option value="was not">{constants.No}</Option>
							</Select>
						</Form.Item>
					</Col>
					{isEmotional11Selected && (<Col xs={24} sm={12} lg={8}>
						<Form.Item name={"hospital_details"} label={"Hospital Details"}>
							<Input placeholder={"Hospital Details"} />
						</Form.Item>
					</Col>)}
					<Col xs={24} sm={12} lg={8}>
						<Form.Item name="emotional_12" label={"Are you on any medication for the same?"}>
							<Select placeholder={constants.YesNo} allowClear onChange={handleEmotional12Change}>
								<Option value="medication">{constants.Yes}</Option>
								<Option value="no medication">{constants.No}</Option>
							</Select>
						</Form.Item>
					</Col>
					{isEmotional12Selected && (<Col xs={24} sm={12} lg={8}>
						<Form.Item name={"emotional_5"} label={"Medication Details"}>
							<Input placeholder={"medication"} />
						</Form.Item>
					</Col>)}

					<Col xs={24} md={16}>
						<Form.Item
							label="Family history of mental health or emotional health concerns"
							name="family_mental_health"
							rules={[
								{
									required: true,
									message: "Please select an option"
								}
							]}
						>
							<Radio.Group>
								<Radio value="none">No known family history</Radio>
								<Radio value="present">Yes, there is family history</Radio>
								<Radio value="unsure">Not sure/Prefer not to say</Radio>
							</Radio.Group>
						</Form.Item>
					</Col>

					{familyMentalHealthValue === 'present' && (
						<Col xs={24} md={8}>
							<Form.Item
								label="Family mental health history (In details)"
								name="family_mental_health_details"
								rules={[
									{
										required: true,
										message: "Please provide details about the mental health history"
									}
								]}
							>
								<Input.TextArea
									placeholder="e.g., which family members, types of conditions (depression, anxiety, etc.), treatments received, etc."
									rows={1}
								/>
							</Form.Item>
						</Col>
					)}
				</Row>
				<Divider className="my-7" />

				{panelTitle("Medical History")}
				<Row gutter={[12, 12]}>
					<Col xs={24} sm={12} lg={8}>
						<Form.Item
							label="Health Status"
							name={"medical_2"}
							rules={[
								{
									required: true,
									message: "Select health status",
								},
							]}
						>
							<Select placeholder="Good/Poor" allowClear>
								<Option value="good">Good</Option>
								<Option value="fair">Fair</Option>
								<Option value="poor">Poor</Option>
							</Select>
						</Form.Item>
					</Col>

					<Col xs={24} sm={24} lg={16}>
						<Form.Item
							label="When was your last checkup?"
							name="last_checkup_status"
							rules={[
								{
									required: true,
									message: "Select when your last checkup was",
								},
							]}
						>
							<Radio.Group>
								<Space direction="horizontal">
									<Radio value="1" className="dob-mb-0">
										{DOB(
											date.month,
											handleMonthChange,
											date.date,
											handleDayChange,
											date.year,
											handleYearChange,
											"",
											false
										)}
									</Radio>
									<Radio value="2">Don't Remember</Radio>
								</Space>
							</Radio.Group>
						</Form.Item>
					</Col>

					<Col xs={24} sm={12} lg={8}>
						<Form.Item
							label="Allergies"
							name="medical_4"
							rules={[
								{
									required: true,
									message: "Select Allergies/no Allergies",
								},
							]}
						>
							<Select placeholder="Allergies/no Allergies" allowClear onChange={handleMedical4Change}>
								<Option value="Allergies">Allergies</Option>
								<Option value="no Allergies">no Allergies</Option>
							</Select>
						</Form.Item>
					</Col>
					{isMedical4Selected && (<Col xs={24} sm={12} lg={8}>
						<Form.Item name={"medical_5"} label={"Allergie Details"}>
							<Input placeholder={"Allergie Details"} />
						</Form.Item>
					</Col>)}
					<Col xs={24} sm={12} lg={8}>
						<Form.Item
							label={
								<span>
									Other Medications{' '}
									<Tooltip title="OTCs means Over-the-Counter medications (available without a prescription)">
										<InfoCircleOutlined style={{ color: '#1890ff' }} />
									</Tooltip>
								</span>
							}
							name="medical_8"
							rules={[
								{
									required: true,
									message: "Select no/medications/OTCs",
								},
							]}
						>
							<Select placeholder="no/medications/OTCs" allowClear onChange={handleMedical8Change}>
								<Option value="medications/OTCs">Medications/OTCs</Option>
								<Option value="no medications/OTCs">no Medications/OTCs</Option>
							</Select>
						</Form.Item>
					</Col>
					{isMedical8Selected && (<Col xs={24} sm={12} lg={8}>
						<Form.Item name={"medical_9"} label={"Other Medications/OTCs Details"}>
							<Input placeholder={"medications/OTCs"} />
						</Form.Item>
					</Col>)}
					<Col xs={24} sm={24} lg={8}>
						<Form.Item
							name="medical_10"
							label={"Dietary Habbits"}
							rules={[
								{
									required: true,
									message: "Select Dietary Habbits",
								},
							]}
						>
							<Select placeholder={constants.DietaryHabbitsPlaceHolder} style={{ minWidth: '200px', }}>
								{
									constants.DietaryHabbits.map((diet) => {
										return <Option key={diet.key} value={diet.key}>{diet.label}</Option>
									})
								}
							</Select>
						</Form.Item>
					</Col>

					<Col xs={24} sm={24} lg={8}>
						<Form.Item name="medical_6" label="Do you have any illnesses/diseases?">
							<Select placeholder="illnesses/no illnesses" allowClear onChange={handleMedical6Change}>
								<Option value="illnesses/disease">illnesses/diseases</Option>
								<Option value="no illnesses/disease">no illnesses/diseases</Option>
							</Select>
						</Form.Item>
					</Col>
					{isMedical6Selected && (<>
						<Col xs={24}>
							<Form.Item label="Select Illnesses/diseases">
								<Checkbox.Group onChange={handleIllnessChange} value={selectedIllnesses}>
									<Row gutter={[12, 12]}>
										{filteredIllnessOptions.map((value) => (
											<Col xs={24} sm={12} lg={8} key={value.value}>
												<Checkbox value={value.value}>
													<p>{value.label}</p>
												</Checkbox>
											</Col>
										))}
									</Row>
								</Checkbox.Group>
							</Form.Item>
						</Col>

						{selectedIllnesses.includes('Other') && (
							<Col xs={24} sm={24} lg={8}>
								<Form.Item label="Other Illness" name={"other_illness"}>
									<TextArea
										value={otherIllness}
										onChange={(e) => setOtherIllness(e.target.value)}
										rows={1}
										placeholder="Enter other illness"
									/>
								</Form.Item>
							</Col>
						)}
					</>
					)}

				</Row>

				{/* <div className="font-bold mb-2">{constants.MentalHealthTxt}</div>

				<Checkbox.Group onChange={handleCheckboxMentalHealthOption} value={selectedMentalHealthOption}>
					<Row gutter={[12, 12]}>
						{constants.MentalHealthOptions.map((value) => (
							<Col xs={24} sm={12} lg={8} key={value.value}>
								<Checkbox value={value.value}>
									<p>{value.label}</p>
								</Checkbox>
							</Col>
						))}
					</Row>
				</Checkbox.Group>

				{selectedMentalHealthOption.includes("other_major_physical") && (
					<div className="mt-3">
						<Input
							placeholder="Please specify other major physical health condition"
							value={otherMajorHealthDetail}
							onChange={(e) => setOtherMajorHealthDetail(e.target.value)}
						/>
					</div>
				)} */}
				<Divider className="my-7" />

				{panelTitle("Family & Lifestyle:")}

				<Row gutter={16}>
					<Col xs={24} md={12} lg={8}>
						<Form.Item
							name="maritalstatus"
							label={constants.MaritalStatus}
							rules={[
								{
									required: true,
									message: `Please select ${constants.MaritalStatus}`,
									whitespace: true
								},
							]}
						>
							<Select placeholder={`Select ${constants.MaritalStatus}`} allowClear>
								{constants.MaritalStatusOption.map((val) => {
									return <Option key={val.value} value={val.value}>{val.label}</Option>
								})}
							</Select>
						</Form.Item>
					</Col>
					<Col xs={24} md={12} lg={8}>
						<Form.Item
							label="Father's Name"
							name="father_name"
							rules={[
								{
									required: true,
									message: "Please enter father's name",
								},
							]}
						>
							<Input placeholder="Enter father's name" />
						</Form.Item>
					</Col>
					<Col xs={24} md={12} lg={8}>
						<Form.Item
							label="Mother's Name"
							name="mother_name"
							rules={[
								{
									required: true,
									message: "Please enter mother's name",
								},
							]}
						>
							<Input placeholder="Enter mother's name" />
						</Form.Item>
					</Col>
					<Col xs={24} md={12} lg={8}>
						<Form.Item
							label="Relationship with Parents"
							name="family_4"
							rules={[
								{
									required: true,
									message: "Please select your relationship with parents",
								},
							]}
						>
							<Select placeholder="Fair/Good/Poor" allowClear>
								<Option value="fair">Fair</Option>
								<Option value="good">Good</Option>
								<Option value="poor">Poor</Option>
							</Select>
						</Form.Item>
					</Col>
					<Col xs={24} md={12} lg={8}>
						<Form.Item
							name="family_1"
							label="Birth Order"
							rules={[
								{
									required: true,
									message: "Please select your birth order",
								},
							]}
						>
							{customSelect(true, "birth order", null, birthOrder, addBirthOrder, newBirthOrder, (e) => setNewBirthOrder(e.target.value), birthOrderInputRef, null, handleFamily1Change)}
						</Form.Item>
					</Col>
					{!isFamily1Selected && (
						<>
							<Col xs={24} md={12} lg={8}>
								<Form.Item
									label="Relationship with Siblings"
									name="family_16"
									rules={[
										{
											message: "Please select your relationship with siblings",
										},
									]}
								>
									<Select placeholder="Fair/Good/Poor" allowClear>
										<Option value="fair">Fair</Option>
										<Option value="good">Good</Option>
										<Option value="poor">Poor</Option>
									</Select>
								</Form.Item>
							</Col>
							<Col className="pt-1" xs={24} lg={24}>
								<div className="text-sm font-bold mb-2">{constants.SiblingTxt}</div>
							</Col>
							{dynamicForm("siblings")}
						</>
					)}
				</Row>

				<Row gutter={16}>
					<Col xs={24} md={12} lg={8}>
						<Form.Item
							label="Partner's Name (if applicable)"
							name="spouse_name"
						>
							<Input placeholder="Enter partner's name" />
						</Form.Item>
					</Col>

					<Col xs={24} md={12} lg={8}>
						<Form.Item
							label="Relationship with Partner"
							name="family_5"
						>
							<Select placeholder="Fair/Good/Poor" allowClear>
								<Option value="fair">Fair</Option>
								<Option value="good">Good</Option>
								<Option value="poor">Poor</Option>
							</Select>
						</Form.Item>
					</Col>

					<Col xs={24} md={12} lg={8}>
						<Form.Item
							name="family_3"
							label="Current Living Situation"
							rules={[
								{
									required: true,
									message: "Please describe your living arrangements",
								},
							]}
						>
							{customSelect(true, "living alone/with spouse/partner & children/joint family", null, living, addLiving, newLiving, (e) => setNewLiving(e.target.value), livingInputRef, null, (value) => setSelectedLiving(value), null, selectedLiving)}
						</Form.Item>
					</Col>

					{loginType !== "0" && selectedLiving !== 'living alone' && selectedLiving !== '' && (
						<Col xs={24} md={12}>
							{customRadio('supportive_family', 'Are they supportive of your recovery?', "yes", "no")}
						</Col>
					)}

					<Col className="pt-3" xs={24} lg={24}>
						<div className="text-sm font-bold mb-2">{constants.ChildrenTxt}</div>
					</Col>
					{dynamicForm("children")}
				</Row>
				<Divider className="mt-3 mb-7" />

				{panelTitle("Other Social Information:")}
				<Row gutter={16}>
					<Col xs={24} md={12} lg={8}>
						<Form.Item
							name={"family_10"}
							label="Education (highest level completed)"
							rules={[
								{
									required: true,
									message: "Enter Education",
								},
							]}
						>
							<Select placeholder={"Education"} allowClear onChange={handleEducationChange} optionLabelProp="label">
								{constants.EducationOptions.map((val) => {
									return <Option key={val.value} value={val.value} label={val.label}><div className="whitespace-normal">{val.label}</div></Option>
								})}
							</Select>
						</Form.Item>
					</Col>
					{
						showEducationDetails ?
							<Col xs={24} md={12} lg={8}>
								<Form.Item
									name={"education_details"}
									label={"Details"}
								>
									<Input type="text" />
								</Form.Item>
							</Col> : null
					}
					<Col xs={24} md={12} lg={8}>
						<Form.Item
							name="family_11"
							label="Occupation"
							rules={[
								{
									required: true,
									message: "Select occupation",
								},
							]}
						>
							<Select placeholder={"Occupation"} allowClear>
								{constants.OccupationOptions.map((val) => {
									return <Option key={val.value} value={val.value}>{val.label}</Option>
								})}
							</Select>
						</Form.Item>
					</Col>
					<Col xs={24} md={12} lg={8}>
						<Form.Item
							name={"family_8"}
							label={"Legal issues"}
							rules={[
								{
									required: true,
									message: "Enter legal issues",
								},
							]}
						>
							<Select placeholder="No/Current" allowClear onChange={handleFamily8Change}>
								<Option value="no">No</Option>
								<Option value="current">Current</Option>
							</Select>
						</Form.Item>
					</Col>
					{isFamily8Selected && (
						<Col xs={24} md={12} lg={8}>
							<Form.Item
								name={"family_9"}
								label={"Legal issue Details"}
							>
								<Input placeholder={"legal issue Details"} />
							</Form.Item>
						</Col>
					)}

					<Col xs={24} md={12} lg={8}>
						<Form.Item
							label="Exercise"
							required
							rules={[{ required: true, message: "Select at least one option" }]}
							name={"excercise"}
						>
							<Checkbox.Group
								options={['Walks', 'Gym', 'Sports', 'Other', 'None']}
								value={selectedExercises}
								onChange={handleExerciseChange}
							/>
						</Form.Item>
					</Col>

					{selectedExercises.includes('Other') && (
						<Col xs={24} md={12} lg={8}>
							<Form.Item
								label="Other Exercise"
								name="other_exercise"
								required
								rules={[{ required: true, message: 'Enter exercise type' }]}
							>
								<Input
									placeholder="Enter other exercise"
									value={otherExercise}
									onChange={(e) => setOtherExercise(e.target.value)}
								/>
							</Form.Item>
						</Col>
					)}
					{
						history.location.pathname === "/edit-self-assessment-summary" ?
							<div className="form-mb-0">
								{assessment()}
								{plan()}
							</div> :
							null
					}

					{/* Hidden field for submission */}
					<Form.Item name="family_13" noStyle>
						<Input type="hidden" />
					</Form.Item>

					<Form.Item name="family_14" noStyle>
						<Input type="hidden" />
					</Form.Item>

					<Form.Item name="family_15" noStyle>
						<Input type="hidden" />
					</Form.Item>

				</Row>

				<Divider />
				<Form.Item>
					{!hideButtons && <Space>
						{loginType !== "0" && <Button className='bg-sky-800 text-white uppercase' onClick={hideModal}>{constants.Cancel}</Button>}
						<Form.Item className="mb-0">
							<Button className='bg-sky-800 text-white uppercase' type='primary' /* htmlType="submit" */ onClick={() => handleSave()}>
								{constants.Save}
							</Button>
						</Form.Item>
						{loginType !== "0" && <Popconfirm title="You will not be able to Edit after you Esign the Notes" onConfirm={() => handleSave("esign")}>
							<Button className='bg-sky-800 text-white uppercase'>{constants.Esign}</Button>
						</Popconfirm>}
					</Space>}
				</Form.Item>
			</Form>
			<Modal
				title="Primary Substance"
				open={isDrugModalOpen}
				onCancel={() => setIsDrugModalOpen(false)}
				footer={null}
			>
				{
					!validatePanel3() && ( // Show error message if validation fails
						<span className="text-red-500 text-sm">{constants.OptionValidationMessage}</span>
					)
				}
				<div className="grid grid-cols-2 gap-3">
					{constants.Substances
						.filter((sub) => sub.key !== "gambling" && sub.key !== "no_gambling" && sub.key !== "social_gambling")
						.map((sub) => (
							<Checkbox
								key={sub.key}
								onChange={(e) => {
									handleCheckboxSubChange(sub.key, e.target.checked)
								}}
								checked={!!selectedSubstances?.[sub.key]?.checked}
							>
								<Tooltip title={constants.SubstancesAliases[sub.key]}> <p className='text-[14px]'><b>{sub.substances}</b></p></Tooltip>
							</Checkbox>
						))}
				</div>
			</Modal>
		</Spin>
	);
};

export default EditableCheatSheet;